import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ElementTag from '../internal/ElementTag';

export class SvgComponent extends Component {
  static displayName = 'SvgComponent';

  static handledProps = ['title', 'description'];

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    xmlns: PropTypes.string,
    role: PropTypes.string,
    version: PropTypes.string,
  };

  static defaultProps = {
    as: 'svg',
    role: 'img',
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidCatch(error) {
    // Because IE.
    this.setState({
      error,
    });
  }

  render() {
    const { as, className, title, description, children, ...rest } = this.props;
    const { error } = this.state;
    const ariaLabel = [title, description].filter(Boolean).join(' ');

    if (!ariaLabel) {
      rest.role = undefined;
      rest['aria-hidden'] = true;
    } else {
      rest['aria-label'] = ariaLabel;
    }

    return (
      <ElementTag as={as} className={['svg', className]} {...rest}>
        {!error && title && <title>{title}</title>}
        {!error && description && <desc>{description}</desc>}
        {children}
      </ElementTag>
    );
  }
}

export default SvgComponent;
